import React from "react";

const MoonIcon = (props) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        {...props}
      >
        <path
          data-name="Icon feather-moon"
          d="M21.352 12.092A10.2 10.2 0 1 1 10.26 1a7.931 7.931 0 0 0 11.092 11.092Z"
          fill="none"
          stroke="#202d5b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
      </svg>
    </>
  );
};

export default MoonIcon;
